import { useState } from 'react';

type AutocompleteSession = {
  token: string;
  rotate: () => void;
};

const mint = (): string => crypto.randomUUID();

/**
 * The correlation token for one typing episode — every search the customer's
 * keystrokes produce, plus the resolution that ends it.
 *
 * A provider that bills per episode groups the whole run under this token, so
 * getting it wrong costs money and shows nothing: every feature still works, the
 * searches are simply billed one by one. Which is why both halves live here
 * rather than being left to a call site to remember — one token for the episode,
 * and a new one the moment the previous episode ends.
 */
export const useAutocompleteSession = (): AutocompleteSession => {
  const [token, setToken] = useState(mint);

  return { token, rotate: () => setToken(mint()) };
};
